import { render, staticRenderFns } from "./k-btn.vue?vue&type=template&id=1e3d4514"
import script from "./k-btn.vue?vue&type=script&lang=js"
export * from "./k-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports